<template>
	<transition appear type="animation" :enter-active-class="state" @after-enter="complete">
		<div class="cover cat-animation"></div>
	</transition>
</template>

<script>
import soundFx from '@/mixins/sound-fx';

export default {
	name: 'Poof',
	mixins: [soundFx],
	props: ["state"],
	computed: {
		transitionClass() {
			return this.state === "satisfied" ? "satisfied" : "unsatisfied";
		},
	},
	methods: {
		complete() {
			this.$emit("completedPoof");
		},
	},
	mounted() {
		this.playRandomSound(this.state);
	},
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/cat/Poof.vue